import { createContext, PropsWithChildren, useContext } from 'react';
import { useFieldArray, UseFieldArrayReturn, useFormContext } from 'react-hook-form';
import { DocumentBuilderForm } from '~/types/document-builder';

const relatedDocumentsFieldArrayContext = createContext<UseFieldArrayReturn<
  DocumentBuilderForm,
  'relatedDocuments'
> | null>(null);
const withholdingsFieldArrayContext = createContext<UseFieldArrayReturn<DocumentBuilderForm, 'withholdingTax'> | null>(
  null,
);
const itemsFieldArrayContext = createContext<UseFieldArrayReturn<DocumentBuilderForm, 'items'> | null>(null);

export const FieldArrayContextProvider = ({ children }: PropsWithChildren) => {
  const { control } = useFormContext<DocumentBuilderForm>();
  const relatedDocumentsFieldArray = useFieldArray({ control, name: 'relatedDocuments' });
  const withholdingsFieldArray = useFieldArray({ control, name: 'withholdingTax' });
  const itemsFieldArray = useFieldArray({ control, name: 'items' });
  return (
    <relatedDocumentsFieldArrayContext.Provider value={relatedDocumentsFieldArray}>
      <withholdingsFieldArrayContext.Provider value={withholdingsFieldArray}>
        <itemsFieldArrayContext.Provider value={itemsFieldArray}>{children}</itemsFieldArrayContext.Provider>
      </withholdingsFieldArrayContext.Provider>
    </relatedDocumentsFieldArrayContext.Provider>
  );
};

export const useRelatedDocumentsFieldArray = () => {
  const context = useContext(relatedDocumentsFieldArrayContext);

  if (!context)
    throw new Error('useRelatedDocumentsFieldArray must be called from within the FieldArrayContextProvider');

  return context;
};

export const useWithholdingsFieldArray = () => {
  const context = useContext(withholdingsFieldArrayContext);

  if (!context) throw new Error('useWithholdingsFieldArray must be called from within the FieldArrayContextProvider');

  return context;
};

export const useItemsFieldArray = () => {
  const context = useContext(itemsFieldArrayContext);

  if (!context) throw new Error('useItemsFieldArray must be called from within the FieldArrayContextProvider');

  return context;
};
